import { createSlice } from '@reduxjs/toolkit';
import type {PayloadAction} from "@reduxjs/toolkit"
import { IAttachements } from '../../interfaces/Attachments';

const AttachmentsSlice = createSlice({
	name: "attachments",
	initialState: {
		attachments: {},
	},
	reducers: {
		addAttachment(state, action: PayloadAction<{ index: number, stepId: string, assetId: string }>)
		{
			const { stepId, assetId } = action.payload;
			let index = action.payload.index;

			if(!state.attachments[stepId])
			{
				state.attachments[stepId] = [];
				index = 0;
			}

			state.attachments[stepId].splice(index, 0, assetId);
		},
		removeAttachment(state, action: PayloadAction<{ stepId: string, index: number }>)
		{
			const { stepId, index } = action.payload;

			if(state.attachments[stepId])
			{
				state.attachments[stepId].splice(index, 1);
			}
		},
		setAttachment(state, action: PayloadAction<{ stepId: string, index: number, newAssetId: string }>)
		{
			const { stepId, index, newAssetId } = action.payload;

			if(!state.attachments[stepId])
			{
				AttachmentsSlice.actions.addAttachment({stepId: stepId, assetId: newAssetId, index: 0 });
			}
			else
			{
				state.attachments[stepId][index] = newAssetId;
			}
		},
		setStepAttachments(state, action: PayloadAction<{ stepId: string, assetIds: string[] }>)
		{
			const { stepId, assetIds } = action.payload;
			state.attachments[stepId] = [...assetIds];
		},
		loadAttachmentsData(state, action: PayloadAction<IAttachements>)
		{
			state.attachments = {...action.payload};
		},
	}
});

export default AttachmentsSlice;
